/**
 * Formats text by capitalizing first letter of each word and replacing underscores with spaces
 * @param {string} text - The text to format
 * @returns {string} - The formatted text
 */
export const formatText = text => {
  if (!text) return '-';

  // Replace underscores with spaces and split into words
  const words = text.split('_');

  // Capitalize first letter of each word and join with spaces
  return words.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
};

/**
 * Formats a date string into a human-readable format
 * @param {string} dateString - The date string to format
 * @param {string} formatStr - Optional format string (default: 'MMM dd, yyyy')
 * @returns {string} - The formatted date
 */
export const formatDate = (dateString, formatStr = 'MMM dd, yyyy') => {
  if (!dateString) return '-';
  try {
    const { format } = require('date-fns');
    return format(new Date(dateString), formatStr);
  } catch (error) {
    return dateString;
  }
};
